import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { AuthGuard } from '@/components/auth-guard';
import { ParentDashboardPage } from '@/features/members/components';

function ParentRoute(): ReactNode {
  return (
    <AuthGuard>
      <ParentDashboardPage />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/parent')({
  component: ParentRoute,
});
